var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slices"},[_vm._l((_vm.slices),function(slice,index){return [_c(_vm.sliceType(slice.slice_type),{key:index,tag:"component",attrs:{"slice":slice}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }